import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.a`
  display: flex;
  flex-direction: column;
  width: 11vw;
  height: 24vh;
  background: ${colors.WHITE};
  border-radius: 1rem;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
`;

export const IconContaniner = styled.div`
  display: flex;
  width: 100%;
  height: 70%;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const IconDeleteContaniner = styled.div`
  position: absolute;
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  z-index: 100;
  right: -1rem;
  top: -1rem;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  display: flex;
  width: 100%;
  height: 30%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = {
  fontFamily: 'metropolis',
  fontWeight: 'bold',
  fontSize: '1vmax',
  color: colors.BLACK,
};

export const TitleUpload = {
  fontFamily: 'metropolis',
  fontSize: '1vmax',
  color: colors.BLACK,
  paddingBottom: '0.7rem',
};

export const Image = {
  width: '40%',
  height: '50%',
};

export const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

export default {
  CardContainer,
  IconContaniner,
  IconDeleteContaniner,
  InfoContainer,
  Title,
  TitleUpload,
  Image,
  containerStyle,
};
